export const SPOTLIGHT_EXTENSION_TYPE = 'com.atlassian.confluence.spotlight';
export const SECTION_EXTENSION_TYPE = 'com.atlassian.confluence.hub-section';
export const KNOWLEDGE_CARDS_EXTENSION_TYPE = 'com.atlassian.confluence.knowledge-cards';
export const DEFAULT_BRANDING_COLOR = '#DDDEE1';
export const HUB_PRIMARY_COLOR_CSS_VAR = '--hub-primary-color';
export const HUB_PRIMARY_TEXT_COLOR_CSS_VAR = '--hub-primary-text-color';
export const SENTRY_DSN = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
export const UNKNOWN_TAG = 'unknown';
